/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_TitleInputs */

const en_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmatic SEO and AI Content Systems`)
};

const ar_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السيو البرمجي وأنظمة المحتوى بالذكاء الاصطناعي`)
};

const bn_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোগ্রাম্যাটিক SEO ও এআই কনটেন্ট সিস্টেম`)
};

const de_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmatische SEO- und KI-Content-Systeme`)
};

const es_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO programático y sistemas de contenido con IA`)
};

const fr_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO programmatique et systèmes de contenu IA`)
};

const pt_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO programático e sistemas de conteúdo com IA`)
};

const zh_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`程序化 SEO 与 AI 内容系统`)
};

const tr_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programatik SEO ve YZ İçerik Sistemleri`)
};

const ru_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программное SEO и ИИ-контент-системы`)
};

const pl_svc_programmatic_seo_title = /** @type {(inputs: Svc_Programmatic_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programatyczne SEO i systemy treści AI`)
};

/**
* | output |
* | --- |
* | "Programmatic SEO and AI Content Systems" |
*
* @param {Svc_Programmatic_Seo_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_title = /** @type {((inputs?: Svc_Programmatic_Seo_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_title(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_title(inputs)
	if (locale === "de") return de_svc_programmatic_seo_title(inputs)
	if (locale === "es") return es_svc_programmatic_seo_title(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_title(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_title(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_title(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_title(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_title(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_title(inputs)
	return en_svc_programmatic_seo_title(inputs)
});
export { svc_programmatic_seo_title as "svc_programmatic-seo_title" }